/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// import { useState } from "react";
import { Menu, Space, Tag, Row } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGauge,
  faMagnifyingGlass,
  faHandshake,
  faUsers,
  faUserShield,
  faBuilding,
  faChartLine,
  faFileWaveform,
  faPlugCircleExclamation,
  faCog,
  faIdBadge,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import _ from "lodash";
import TheLendingTreeSvg from "../svgs/LendingTreeSvg";
import { IoClose } from "react-icons/io5";
import { useCallback, useEffect, useState } from "react";

import useAppStore from "../../store/zustand-store/app.store";

function Sidenav({ color }) {
  const currentUser = useSelector((state) => state.auth.user);
  const rawPermission = useSelector(
    (state) => state?.auth?.user?.role?.permission?.permission
  );
  const permissions = rawPermission
    ? JSON.parse(rawPermission).strPermission
    : [];
  // console.log("permissions", permissions);
  const { isSidebarLTPortalCollapse, setSidebarLTPortalCollapse } =
    useAppStore();

  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const profile = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const sidebarToggleClass = (collapse) => {
    document.body.classList.toggle("mobile-expand", false);
  };

  return (
    <>
      <div
        onClick={() => sidebarToggleClass()}
        className="sidebar-close-btn absolute top-2 right-2 text-white hover:text-white/50 hover:cursor-pointer"
      >
        <IoClose size={28} />
      </div>
      <div className="brand px-2">
        <a href="/">
          <TheLendingTreeSvg
            className="hover:cursor-pointer fill-white"
            size={isSidebarLTPortalCollapse ? 30 : 40}
            hideText={isSidebarLTPortalCollapse}
          />
        </a>
        <div className="brand-info" style={{ marginTop: 10 }}>
          <div className="py-1 text-white flex flex-col mb-1">
            <div className="text-white/90">Welcome</div>
            <div className="font-semibold word-break">{`${currentUser?.firstName} ${currentUser?.lastName}`}</div>
          </div>
          <Tag
            color="#04395E"
            size="medium"
            className="px-2 py-1 rounded-lg"
            icon={<FontAwesomeIcon icon={faIdBadge} />}
          >
            {currentUser?.role.name || ""}
          </Tag>
        </div>
      </div>
      <hr />
      <Menu theme="light" mode="inline">
        {_.find(permissions, { id: "dashboard" })?.state === 1 && (
          <Menu.Item key="1">
            <NavLink to="/dashboard">
              <span
                className="icon"
                style={{
                  background: page === "dashboard" ? color : "",
                }}
              >
                <FontAwesomeIcon icon={faGauge} />
              </span>
              <span className="label">Dashboard</span>
            </NavLink>
          </Menu.Item>
        )}
        {_.find(permissions, { id: "leads" })?.state === 1 && (
          <Menu.Item key="2">
            <NavLink to="/leads">
              <span
                className="icon"
                style={{
                  background: page === "leads" ? color : "",
                }}
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </span>
              <span className="label">Leads</span>
            </NavLink>
          </Menu.Item>
        )}
        {_.find(permissions, { id: "deals" })?.state === 1 && (
          <Menu.Item key="3">
            <NavLink to="/cases">
              <span
                className="icon"
                style={{
                  background: page === "cases" ? color : "",
                }}
              >
                <FontAwesomeIcon icon={faHandshake} />
              </span>
              <span className="label">Cases</span>
            </NavLink>
          </Menu.Item>
        )}
        {_.find(permissions, { id: "reports" })?.state === 1 && (
          <Menu.Item key="4">
            <NavLink to="/reports">
              <span
                className="icon"
                style={{
                  background: page === "reports" ? color : "",
                }}
              >
                <FontAwesomeIcon icon={faChartLine} />
              </span>
              <span className="label">Reports</span>
            </NavLink>
          </Menu.Item>
        )}

        {_.find(permissions, { id: "users" })?.state === 1 && (
          <>
            <div className="side-group-header text-[0.8rem] text-white/60 inline-block uppercase tracking-wide px-0 py-4">
              Admin Settings
            </div>
            <Menu.Item key="users">
              <NavLink to="/users">
                <span
                  className="icon"
                  style={{
                    background: page === "users" ? color : "",
                  }}
                >
                  <FontAwesomeIcon icon={faUsers} />
                </span>
                <span className="label">Users</span>
              </NavLink>
            </Menu.Item>
          </>
        )}
        {_.find(permissions, { id: "unsyncleads" })?.state === 1 && (
          <>
            <Menu.Item key="unsyncleads">
              <NavLink to="/unsyncleads">
                <span
                  className="icon"
                  style={{
                    background: page === "unsyncleads" ? color : "",
                  }}
                >
                  <FontAwesomeIcon icon={faPlugCircleExclamation} />
                </span>
                <span className="label">Unsync Leads</span>
              </NavLink>
            </Menu.Item>
          </>
        )}
        {_.find(permissions, { id: "activitylogs" })?.state === 1 && (
          <>
            <Menu.Item key="activitylogs">
              <NavLink to="/activitylogs">
                <span
                  className="icon"
                  style={{
                    background: page === "activitylogs" ? color : "",
                  }}
                >
                  <FontAwesomeIcon icon={faFileWaveform} />
                </span>
                <span className="label">Activity Logs</span>
              </NavLink>
            </Menu.Item>
          </>
        )}
        {_.find(permissions, { id: "roles" })?.state === 1 && (
          <>
            <Menu.Item key="6">
              <NavLink to="/roles">
                <span
                  className="icon"
                  style={{
                    background: page === "roles" ? color : "",
                  }}
                >
                  <FontAwesomeIcon icon={faUserShield} />
                </span>
                <span className="label">Roles & Permissions</span>
              </NavLink>
            </Menu.Item>
          </>
        )}
        {_.find(permissions, { id: "companies" })?.state === 1 && (
          <Menu.Item key="7">
            <NavLink to="/companies">
              <span
                className="icon"
                style={{
                  background: page === "companies" ? color : "",
                }}
              >
                <FontAwesomeIcon icon={faBuilding} />
              </span>
              <span className="label">Companies</span>
            </NavLink>
          </Menu.Item>
        )}
        {_.find(permissions, { id: "settings" })?.state === 1 && (
          <Menu.Item key="8">
            <NavLink to="/settings">
              <span
                className="icon"
                style={{
                  background: page === "settings" ? color : "",
                }}
              >
                <FontAwesomeIcon icon={faCog} />
              </span>
              <span className="label">Settings</span>
            </NavLink>
          </Menu.Item>
        )}
        <div className="side-group-header text-[0.8rem] text-white/60 inline-block uppercase tracking-wide px-0 py-4">
          Your Account
        </div>
        <Menu.Item key="10">
          <NavLink to="/profile">
            <span
              className="icon"
              style={{
                background: page === "profile" ? color : "",
              }}
            >
              {profile}
            </span>
            <span className="label">Profile</span>
          </NavLink>
        </Menu.Item>
      </Menu>
    </>
  );
}

export default Sidenav;
